import { type Config, type DexfSegment, Env } from "@inter-ikea-space-platform/config";

const BASE_PATH = process.env.PUBLIC_PATH || "";
const ENV = (process.env.APPLICATION_ENV || "local-dev") as Env;

export const config: Config = {
  rooms: [
    {
      name: "bathroom",
      screensaverUrl: "/addon-app/space/experience/bathroom/assets/bath_screensaver.mp4",
      titleTranslationKey: "bathroomNavigationTitleText",
      vpcApplicationId: "bathroom",
      vpcCode: "TW37RJ",
      icon: "bathroom",
      roomTranslationKey: "roomTypeBathroom",
      landingPage: {
        startFromScratchImage: `${BASE_PATH}assets/bathroom.png`,
        openDesignImage: `${BASE_PATH}assets/bathroom-open-design.png`,
      },
      inspirationalImageSrc: `${BASE_PATH}assets/bathroom-inspirational.jpg`,
      enablePrintoutMeasurements: true,
    },
    {
      name: "bedroom",
      titleTranslationKey: "bedroomNavigationTitleText",
      vpcApplicationId: "bedroom",
      vpcCode: "TW37LY",
      icon: "bedroom",
      roomTranslationKey: "roomTypeBedroom",
      summaryExpertCheck: true,
      landingPage: {
        startFromScratchImage: `${BASE_PATH}assets/bedroom.png`,
        openDesignImage: `${BASE_PATH}assets/bedroom-open-design.png`,
      },
      inspirationalImageSrc: `${BASE_PATH}assets/bedroom-inspirational.jpg`,
      bookAppointmentImageSrc: `${BASE_PATH}assets/book-online-appointment.jpg`,
      bookAppointmentInGlobalMenu: true,
    },
    {
      name: "workspace",
      titleTranslationKey: "workspaceNavigationTitleText",
      vpcApplicationId: "workspacerange",
      vpcCode: "TW37WC",
      icon: "officeChair",
      roomTranslationKey: "roomTypeWorkspace",
      landingPage: {
        startFromScratchImage: `${BASE_PATH}assets/workspace.png`,
        openDesignImage: `${BASE_PATH}assets/workspace-open-design.png`,
      },
      inspirationalImageSrc: `${BASE_PATH}assets/workspace-inspirational.jpg`,
    },
    {
      name: "hallway",
      titleTranslationKey: "hallwayNavigationTitleText",
      roomTranslationKey: "roomTypeHallway",
      vpcApplicationId: "hallway",
      vpcCode: "TW384Z",
      icon: "furnitureSet",
      landingPage: {
        startFromScratchImage: `${BASE_PATH}assets/hallway.png`,
        openDesignImage: `${BASE_PATH}assets/hallway-open-design.png`,
      },
      inspirationalImageSrc: `${BASE_PATH}assets/hallway-inspirational.jpg`,
    },
    {
      name: "dining",
      titleTranslationKey: "navigationTitleText",
      roomTranslationKey: "roomTypeDining",
      vpcApplicationId: "dining",
      vpcCode: "Z2QWZV",
      icon: "chair",
      landingPage: {
        startFromScratchImage: `${BASE_PATH}assets/dining.png`,
        openDesignImage: `${BASE_PATH}assets/dining-open-design.png`,
        showroom: {
          imageUrl: `${BASE_PATH}assets/germany-showroom.jpg`,
          titleTranslationKey: "livingRoomShowroomTitle",
          headerTranslationKey: "livingRoomShowroomSectionHeader",
        },
      },
      inspirationalImageSrc: `${BASE_PATH}assets/dining-inspirational.jpg`,
    },
    {
      name: "living-room",
      titleTranslationKey: "livingRoomNavigationTitleText",
      roomTranslationKey: "roomTypeLivingRoom",
      vpcApplicationId: "livingroom",
      vpcCode: "SWHRJQ",
      icon: "sofa",
      landingPage: {
        startFromScratchImage: `${BASE_PATH}assets/living-room.png`,
        openDesignImage: `${BASE_PATH}assets/living-room-open-design.png`,
        showroom: {
          imageUrl: `${BASE_PATH}assets/germany-showroom.jpg`,
          titleTranslationKey: "livingRoomShowroomTitle",
          headerTranslationKey: "livingRoomShowroomSectionHeader",
        },
      },

      inspirationalImageSrc: `${BASE_PATH}assets/living-room-inspirational.jpg`,
    },
    {
      name: "outdoor",
      titleTranslationKey: "outdoorNavigationTitleText",
      roomTranslationKey: "roomTypeOutdoor",
      vpcApplicationId: "outdoor",
      vpcCode: "YLLVNS",
      icon: "parasol",
      landingPage: {
        startFromScratchImage: `${BASE_PATH}assets/outdoor.jpg`,
        openDesignImage: `${BASE_PATH}assets/outdoor-open-design.jpg`,
      },
      materialTags: ["outdoor"],
      onboarding: {
        introductionTranslationKey: "outdoorOnboardingIntroduction",
        introductionImageSrc: `${BASE_PATH}assets/outdoor-inspirational.jpg`,
        retrieveOnboardingCardTitle: "retrieveOnboardingOutdoorCardTitle",
        retrieveOnboardingCardLabel: "retrieveOnboardingOutdoorCardLabel",
        steps: [
          {
            step: 1,
            titleTranslationKey: "outdoorOnboardingStepOneTitle",
            contentTranslationKey: "outdoorOnboardingStepOneContent",
            imageSrc: `${BASE_PATH}assets/outdoor-onboarding-step-one.jpg`,
          },
          {
            step: 2,
            titleTranslationKey: "outdoorOnboardingStepTwoTitle",
            contentTranslationKey: "outdoorOnboardingStepTwoContent",
            imageSrc: `${BASE_PATH}assets/outdoor-onboarding-step-two.jpg`,
          },
          {
            step: 3,
            titleTranslationKey: "outdoorOnboardingStepThreeTitle",
            contentTranslationKey: "outdoorOnboardingStepThreeContent",
            imageSrc: `${BASE_PATH}assets/outdoor-onboarding-step-three.jpg`,
          },
        ],
      },
      inspirationalImageSrc: `${BASE_PATH}assets/outdoor-inspirational.jpg`,
    },
    {
      name: "childrens-room",
      titleTranslationKey: "childrensRoomNavigationTitleText",
      roomTranslationKey: "roomTypeChildrensRoom",
      vpcApplicationId: "childrensroom",
      vpcCode: "TP7VZ6",
      icon: "playArea",
      inspirationalImageSrc: `${BASE_PATH}assets/childrens-room-inspirational.jpg`,
      landingPage: {
        startFromScratchImage: `${BASE_PATH}assets/childrens-room.png`,
        openDesignImage: `${BASE_PATH}assets/childrens-room-open-design.png`,
      },
      onboarding: {
        introductionTranslationKey: "childrensRoomSafetyOnboardingIntroduction",
        introductionImageSrc: `${BASE_PATH}assets/childrens-room-safety-introduction.jpg`,
        retrieveOnboardingCardTitle: "retrieveOnboardingChildrensCardTitle",
        retrieveOnboardingCardLabel: "retrieveOnboardingChildrensCardLabel",
        steps: [
          {
            step: 1,
            titleTranslationKey: "childrensRoomSafetyOnboardingStepOneTitle",
            contentTranslationKey: "childrensRoomSafetyOnboardingStepOneContent",
            imageSrc: `${BASE_PATH}assets/childrens-room-safety-step-one.jpg`,
          },
          {
            step: 2,
            titleTranslationKey: "childrensRoomSafetyOnboardingStepTwoTitle",
            contentTranslationKey: "childrensRoomSafetyOnboardingStepTwoContent",
            imageSrc: `${BASE_PATH}assets/childrens-room-safety-step-two.jpg`,
          },
          {
            step: 3,
            titleTranslationKey: "childrensRoomSafetyOnboardingStepThreeTitle",
            contentTranslationKey: "childrensRoomSafetyOnboardingStepThreeContent",
            imageSrc: `${BASE_PATH}assets/childrens-room-safety-step-three.jpg`,
          },
        ],
      },
    },
  ],
  settings: {
    applicationName: "space",
    applicationVersion: process.env.APPLICATION_VERSION || "0.1.0",
    defaultRoomType: "bathroom",
    dexfApiKey: "19dd6306-8c44-4dbd-af2a-40a9cae886a0",
    dexfBaseUrl: "https://api.dexf.ikea.com/",
    dexfIcfVersion: "1.1",
    env: ENV,
    kompisLocalizationEndpoints: [
      "/addon-app/translations/kompis-merged-translations/{locale}.json",
      "/addon-app/space/merged-translations/{locale}.json",
    ],
    kompisProxyUrl: process.env.KOMPIS_PROXY_URL || "",
    landingPageSettings: {
      topSection: {
        image: `${BASE_PATH}assets/landing-page-top-section-image.png`,
        altTranslationKey: "landingPageTopSectionImgAlt",
      },
    },
    kvadratSettings: {
      dexfSegment: (process.env.KVADRAT_DEXF_SEGMENT || "production") as DexfSegment,
      lightingOptions: {
        environmentMapUrl: `${BASE_PATH}assets/studio_1.env`,
        environmentMapIntensity: 1.0,
      },
    },
    sentry: {
      dsn: "https://c71d64cf2c6e423a99b545ba2eb7431d@o514642.ingest.sentry.io/4504445618946048",
      ignoreErrors: [
        "Invalid financing option. Missing read_more_link or it is empty.",
        "Element with selector [data-focus-restore-id=",
      ],
    },
    viewerSettings: {
      dracoDecoder: {
        wasmUrl: "/addon-app/space/viewer/v1/draco_wasm_wrapper_gltf.js",
        wasmBinaryUrl: "/addon-app/space/viewer/v1/draco_decoder_gltf.wasm",
        fallbackUrl: "/addon-app/space/viewer/v1/draco_decoder_gltf.js",
      },
      materialShaders: {
        enabled: false,
        maxLights: 10,
      },
      verboseWarnings: ENV !== Env.PROD,
    },
  },
};
